import React from 'react';
import * as Yup from 'yup';
import language from '../languages';
import { firestore } from '../firebase';
import buildQuery from "./EntityUtil";

const meta = (lang) => { 
    return {
        entityName: 'Region',
        entityTitle: 'Regions',
        emptyRow: () => {
            return {
                label: '',
                value: '',
                active: true,
                mainRegion: 'self',
                subRegion: 'self',
                image: 'https://via.placeholder.com/800',
                displayOrder: 0
            }
        },
        collection: 'regions',
        itemsPerPage: 100,
        addButtonText: 'New Region',
        // addButtonText: () => {
        //     return <>Add New </>
        //     },
        hideTitle: true,
        fields: [
            {name: 'label', default: null, dataType: 'string', label: 'Label', input: 'text'},
            {name: 'value', default: null, dataType: 'string', label: 'Value', input: 'text', disableValue: 'id',
                isDisabled: (value)=> {
                    if(value){
                        return true
                    }else{
                        return false
                    }
                }
            },
            {name: 'mainRegion', default: null, dataType: 'array', label: 'Main Region', input: 'select',
                getItems: ()=> {
                    return new Promise((resolve, reject)=> {
                        firestore.collection('regions').where('active', '==', true).where('mainRegion', '==', 'self').get().then(snapshot=>{
                            let regions = [{label: 'Self', value: 'self', selected: false}];
                            snapshot.forEach(doc=>{
                                const selected = false;
                                const data = doc.data();
                                // if(data.mainRegion == 'parent') {
                                    regions.push({ selected, ...data })
                                // }
                            })
                            resolve(regions);
                        });
                    })
                }
            },
            {name: 'subRegion', default: null, dataType: 'array', label: 'Sub Region', input: 'select',
                getItems: ()=> {
                    return new Promise((resolve, reject)=> {
                        // firestore.collection('regions').where('active', '==', true).where('mainRegion', '!=', 'self').where('subRegion', '==', 'self').get().then(snapshot=>{
                        firestore.collection('regions').where('active', '==', true).where('subRegion', '==', 'self').get().then(snapshot=>{
                            // let regions = [{label: 'Self', value: 'self', selected: false}];
                            // snapshot.forEach(doc=>{
                            //     const selected = false;
                            //     const data = doc.data();
                            //     // if(data.mainRegion == 'parent') {
                            //         regions.push({ selected, ...data })
                            //     // }
                            // })
                            // resolve(regions);

                            let regions = [];
                            snapshot.forEach(doc=>{
                                const selected = false;
                                const disabled = false;
                                const data = doc.data();
                                regions.push({ selected, ...data })
                            })
                            for(let i = 0; i < regions.length; i++ ) {
                                const mainRegion = regions.filter(item => item.value == regions[i].mainRegion)[0]
                                if(mainRegion) {
                                    regions[i].label = mainRegion.label + ' - ' + regions[i].label
                                }else {
                                    regions[i].disabled = true
                                }
                            }
                            regions.sort((item1, item2) => item1.label.localeCompare(item2.label))
                            let regionsSelf = [{label: 'Self', value: 'self', selected: false}];
                            let allRegions = regionsSelf.concat(regions)
                            resolve(allRegions);
                        });
                    })
                }
            },
            {name: 'image', default: null, dataType: 'string', label: 'Image', input: 'file'},
            {name: 'displayOrder', default: null, dataType: 'number', label: 'Display Order', input: 'text', type:'number', toFixed: 0},
            {name: 'active', default: true, dataType: 'boolean', label: 'Activate', input: 'switch', color: 'primary'},
        ],
        table: [
            {name: 'image', type: 'field', label: 'Image',
                render: (doc)=> {
                    return (
                        <img component="span" alt={doc.label} src={doc.image} style={{height:75}} />
                    )}
            },
            {name: 'label', type: 'field', label: 'Label'},
            {name: 'value', type: 'field', label: 'Value'},
            {name: 'mainRegion', type: 'field', label: 'Main Region'},
            {name: 'subRegion', type: 'field', label: 'Sub Region'},
            {name: 'displayOrder', type: 'field', label: 'Display Order'},
            {name: 'active', type: 'conditionField', label: 'Status', textForTrue: 'Active', textForFalse: 'Inactive'},
            {name: 'actions', type: 'action', label:'Actions', actions: ['delete', 'edit']}
        ],
        validationSchema: Yup.object({
            label: Yup.string()
                .required(language[lang].Field_Required),
            value: Yup.string()
                .required(language[lang].Field_Required),
            mainRegion: Yup.string()
                .required(language[lang].Field_Required),
            subRegion: Yup.string()
                .required(language[lang].Field_Required),
            displayOrder: Yup.number()
                .typeError("That doesn't look like a quantity")
                .integer("That doesn't look like a quantity")
                .positive("A quantity number can't start with a minus")
                .required(language[lang].Field_Required),
        }),
        filterObject: [],
        defaultOrderBy: ['label', 'asc'],
        searchableColumns: ['label','value'],
        getQuery: (paginationAction, firstRowRef, lastRowRef, filter, searchTerms, orderBy, itemsPerPage) => {
            let query = {};
            query = firestore.collection('regions');
            return buildQuery(query, paginationAction, firstRowRef, lastRowRef, filter, searchTerms, orderBy, itemsPerPage);
        },
        beforeSave: (user, doc)=> {
            return doc
        }
    }
}

export default meta;